import { FileInput_File_default } from "./chunk-AFIC773Z.js";
import { FileInput_default } from "./chunk-LDTYW3DD.js";

// src/elements/FileInput/index.ts
var FileInputComponent = FileInput_default;
FileInputComponent.File = FileInput_File_default;
FileInputComponent.File.displayName = "FileInput.File";
export { FileInputComponent };